import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f026efe4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-warp" }
const _hoisted_2 = { class: "content-warp-item-number" }

import { OptionData } from './type';
import { surveySvg21, surveySvg22, surveySvg23 } from './svg-components/index';
import { selfAdaption, dataProcessing } from './hooks';
import { onMounted, ref } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'pc-module-survey-2',
  props: {
    optionData: {}
  },
  setup(__props: any) {

const porps = __props;
const TaskRef = ref<HTMLDivElement>();
const ContentRef = ref<HTMLDivElement>();
const scale = ref(1);
let comps = [surveySvg21, surveySvg22, surveySvg23];
let _data = dataProcessing(porps.optionData, comps);
onMounted(async () => {
  await selfAdaption(TaskRef, ContentRef, scale);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "survey",
    ref_key: "TaskRef",
    ref: TaskRef,
    style: _normalizeStyle({
      transform: `scale(${scale.value})`,
      transformOrigin: '0 0'
    })
  }, [
    _createElementVNode("div", {
      class: "content",
      ref_key: "ContentRef",
      ref: ContentRef
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(_data), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "content-warp-item",
            key: index
          }, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(item.data), 1),
            (_openBlock(), _createBlock(_resolveDynamicComponent(item.comp), {
              controlColor: `var(--theme-color-${index + 1},#000)`
            }, null, 8, ["controlColor"])),
            _createElementVNode("div", {
              style: _normalizeStyle(index + 1 == 2 ? 'width: 265px' : ''),
              class: "content-warp-item-tip"
            }, _toDisplayString(item.tipsText), 5)
          ]))
        }), 128))
      ])
    ], 512)
  ], 4))
}
}

})